/* eslint-disable no-empty-pattern */
import React from 'react';
import { CustomFormikNumberField } from '../../commons/CustomFormikNumberField';
import { TextWrapper, Wrapper } from './Compliance.Styles';
export var ComplianceForm = function (_a) {
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(CustomFormikNumberField, { name: 'dailyCallLimitRecord', label: 'Daily Call Limit - Record', fullWidth: true }),
            React.createElement(CustomFormikNumberField, { name: 'dailyCallLimitPhone', label: 'Daily Call Limit - Phone', fullWidth: true }))));
};
ComplianceForm.defaultProps = {};
//# sourceMappingURL=Compliance.js.map